// extracted by mini-css-extract-plugin
module.exports = {"tab-root":"Tabs_tab-root__p85Ct","tab-list":"Tabs_tab-list__56nN0","tab-trigger":"Tabs_tab-trigger__n8KNp"};